import { AdditionalAppLogInfo } from 'shared/types/logger';
import { frontendVersionWithBuildNumber } from 'shared/version';
import { LocalStorageManager } from 'services/storage/LocalStorageManager';

export function provideLogInfo(): AdditionalAppLogInfo {
  return {
    user_email: LocalStorageManager.getUserEmailSilent(),
    user_id: LocalStorageManager.getUserIdSilent(),
    client_version: frontendVersionWithBuildNumber || null,
  };
}
